export const fileUploadPreset = {
  fileupload: {
    content: {
        padding: '0',
        gap: '0',
        highlightBorderColor: 'none',
    },
    progressbar: {
      height: '8px',
    },
    css: () => `
      .p-fileupload .p-fileupload-header {
        display: none;
        }
       .p-fileupload.p-fileupload-advanced {
        border: none;
        padding: 0;
       }

        .upload-disabled .p-fileupload-content {
          cursor: not-allowed;
        }

        .upload-disabled .p-fileupload-content .fileupload-empty {
          background-color: var(--neutral--10) !important;
          border-color: var(--neutral--20);
        }
    `
  }
};
